// extracted by mini-css-extract-plugin
export default {"root":"Result__root--YfTb0"};